import React from 'react';
import Navbar from "../Components/Navbar";
import EventData from '../Components/EventData';
import Footer from '../Components/Footer';

export default function EventDetails(props) {

    return (
        <div>
            <Navbar />
            <EventData db={props.db}/>
        </div>
    );
}